import Column from '@components/column'
import Banner from './banner'
import NextAppointment from '@commons/cards/nextScheduleAppointment'
import Schedules from './schedules'
const DoctorAppointmentsPage = () => {
  return (
    <Column
      rowGap={30}
      styleColumn="
        @media(max-width:900px){
            row-gap:20px;
        }
    "
    >
      <Banner />
      <NextAppointment />
      <Schedules />
    </Column>
  )
}

export default DoctorAppointmentsPage
